const communityimage = [
    {
        original: "/images/community/community-1.jpeg",
        thumbnail: "/images/community/community-1.jpeg",
        description: "Retreat Event",
        loading: "lazy"
    },
    {
        original: "/images/community/community-3.jpeg",
        thumbnail: "/images/community/community-3.jpeg",
        description: "Retreat Event",
        loading: "lazy"
    },
    {
        original: "/images/community/community-4.jpeg",
        thumbnail: "/images/community/community-4.jpeg",
        description: "Retreat Event",
        loading: "lazy"
    },
    {
        original: "/images/community/community-5.jpeg",
        thumbnail: "/images/community/community-5.jpeg",
        description: "Retreat Event",
        loading: "lazy"
    },
    {
        original: "/images/community/community-2.jpeg",
        thumbnail: "/images/community/community-2.jpeg",
        description: "Retreat Event",
        loading: "lazy"
    },
    {
        original: "/images/community/community-6.jpeg",
        thumbnail: "/images/community/community-6.jpeg",
        description: "Retreat Event",
        loading: "lazy"
    },
    {
        original: "/images/community/community-7.jpeg",
        thumbnail: "/images/community/community-7.jpeg",
        description: "Retreat Event",
        loading: "lazy"
    }
    ];

const foodprepare = [
    {
        original: "/images/foodprepare/preparefood-1.jpeg",
        thumbnail: "/images/foodprepare/preparefood-1.jpeg",
        description: "Community Food Preparation",
        loading: "lazy"
    },
    {
        original: "/images/foodprepare/preparefood-2.jpeg",
        thumbnail: "/images/foodprepare/preparefood-2.jpeg",
        description: "Community Food Preparation",
        loading: "lazy"
    },
    {
        original: "/images/foodprepare/preparefood-3.jpeg",
        thumbnail: "/images/foodprepare/preparefood-3.jpeg",
        description: "Community Food Preparation",
        loading: "lazy"
    },
    {
        original: "/images/foodprepare/preparefood-4.jpeg",
        thumbnail: "/images/foodprepare/preparefood-4.jpeg",
        description: "Community Food Preparation",
        loading: "lazy"
    },
    {
        original: "/images/foodprepare/preparefood-5.jpeg",
        thumbnail: "/images/foodprepare/preparefood-5.jpeg",
        description: "Community Food Preparation",
        loading: "lazy"
    },
    {
        original: "/images/foodprepare/preparefood-6.jpeg",
        thumbnail: "/images/foodprepare/preparefood-6.jpeg",
        description: "Community Food Preparation",
        loading: "lazy"
    }
    ];

const foodservice = [
    {
        original: "/images/foodservice/foodservice-1.jpeg",
        thumbnail: "/images/foodservice/foodservice-1.jpeg",
        description: "Serving Food",
        loading: "lazy"
    },
    {
        original: "/images/foodservice/foodservice-3.jpeg",
        thumbnail: "/images/foodservice/foodservice-3.jpeg",
        description: "Serving Food",
        loading: "lazy"
    },
    {
        original: "/images/foodservice/foodservice-4.jpeg",
        thumbnail: "/images/foodservice/foodservice-4.jpeg",
        description: "Serving Food",
        loading: "lazy"
    },
    {
        original: "/images/foodservice/foodservice-5.jpeg",
        thumbnail: "/images/foodservice/foodservice-5.jpeg",
        description: "Serving Food",
        loading: "lazy"
    },
    {
        original: "/images/foodservice/foodservice-6.jpeg",
        thumbnail: "/images/foodservice/foodservice-6.jpeg",
        description: "Serving Food",
        loading: "lazy"
    },
    {
        original: "/images/foodservice/foodservice-2.jpeg",
        thumbnail: "/images/foodservice/foodservice-2.jpeg",
        description: "Serving Food",
        loading: "lazy"
    },
    {
        original: "/images/foodservice/foodservice-7.jpeg",
        thumbnail: "/images/foodservice/foodservice-7.jpeg",
        description: "Serving Food",
        loading: "lazy"
    },
    {
        original: "/images/foodservice/foodservice-8.jpeg",
        thumbnail: "/images/foodservice/foodservice-8.jpeg",
        description: "Serving Food",
        loading: "lazy"
    }
    ];

const dramaskits = [
    {
        original: "/images/dramaskit/drama-1.jpeg",
        thumbnail: "/images/dramaskit/drama-1.jpeg",
        description: "SSE Drama Skit",
        loading: "lazy"
    },
    {
        original: "/images/dramaskit/drama-2.jpeg",
        thumbnail: "/images/dramaskit/drama-2.jpeg",
        description: "SSE Drama Skit",
        loading: "lazy"
    },
    {
        original: "/images/dramaskit/drama-3.jpeg",
        thumbnail: "/images/dramaskit/drama-3.jpeg",
        description: "SSE Drama Skit",
        loading: "lazy"
    }
    ];

const exhibition = [
    {
        original: "/images/exhibition/exhibition-1.jpeg",
        thumbnail: "/images/exhibition/exhibition-1.jpeg",
        description: "Exhibition Booth",
        loading: "lazy"
    },
    {
        original: "/images/exhibition/exhibition-2.jpeg",
        thumbnail: "/images/exhibition/exhibition-2.jpeg",
        description: "Exhibition Booth",
        loading: "lazy"
    },
    {
        original: "/images/exhibition/exhibition-3.jpeg",
        thumbnail: "/images/exhibition/exhibition-3.jpeg",
        description: "Exhibition Booth",
        loading: "lazy"
    }
];

const sseImages = [
    {
        original: "/images/sse/sse-program-1.jpeg",
        thumbnail: "/images/sse/sse-program-1.jpeg",
        description: "SSE Activities",
        loading: "lazy"
    },
    {
        original: "/images/sse/sse-program-2.jpeg",
        thumbnail: "/images/sse/sse-program-2.jpeg",
        description: "SSE Activities",
        loading: "lazy"
    },
    {
        original: "/images/sse/sse-program-3.jpeg",
        thumbnail: "/images/sse/sse-program-3.jpeg",
        description: "SSE Activities",
        loading: "lazy"
    },
    {
        original: "/images/sse/sse-program-4.jpeg",
        thumbnail: "/images/sse/sse-program-4.jpeg",
        description: "SSE Activities",
        loading: "lazy"
    },
    {
        original: "/images/sse/sse-program-5.jpeg",
        thumbnail: "/images/sse/sse-program-5.jpeg",
        description: "SSE Activities",
        loading: "lazy"
    },
    {
        original: "/images/sse/sse-program-6.jpeg",
        thumbnail: "/images/sse/sse-program-6.jpeg",
        description: "SSE Activities",
        loading: "lazy"
    }
    ];

const centerEvents = [
    {
        original: "/images/topgallery/event-1.jpeg",
        thumbnail: "/images/topgallery/event-1.jpeg",
        description: "Center Activities",
        loading: "lazy"
    },
    {
        original: "/images/topgallery/event-2.jpeg",
        thumbnail: "/images/topgallery/event-2.jpeg",
        description: "Center Activities",
        loading: "lazy"
    },
    {
        original: "/images/topgallery/event-3.jpeg",
        thumbnail: "/images/topgallery/event-3.jpeg",
        description: "Center Activities",
        loading: "lazy"
    },
    {
        original: "/images/topgallery/event-4.jpeg",
        thumbnail: "/images/topgallery/event-4.jpeg",
        description: "Center Activities",
        loading: "lazy"
    },
    {
        original: "/images/topgallery/event-5.jpeg",
        thumbnail: "/images/topgallery/event-5.jpeg",
        description: "Center Activities",
        loading: "lazy"
    },
    {
        original: "/images/topgallery/event-6.jpeg",
        thumbnail: "/images/topgallery/event-6.jpeg",
        description: "Center Activities",
        loading: "lazy"
    },
    {
        original: "/images/topgallery/event-7.jpeg",
        thumbnail: "/images/topgallery/event-7.jpeg",
        description: "Center Activities",
        loading: "lazy"
    },
    {
        original: "/images/topgallery/event-8.jpeg",
        thumbnail: "/images/topgallery/event-8.jpeg",
        description: "Center Activities",
        loading: "lazy"
    },
    {
        original: "/images/topgallery/event-9.jpeg",
        thumbnail: "/images/topgallery/event-9.jpeg",
        description: "Center Activities",
        loading: "lazy"
    },
    {
        original: "/images/topgallery/event-10.jpeg",
        thumbnail: "/images/topgallery/event-10.jpeg",
        description: "Center Activities",
        loading: "lazy"
    }
]

const articles = [
    {
        title: "Value Education SSE Activities",
        description: "SSE Activities",
        image: "/images/sse/sse-program-1.jpeg",
        url: "/sse"
    },
    {
        title: "Food Community Service",
        description: "Community Service",
        image: "/images/community/community-1.jpeg",
        url: "https://sathyasai.us/media/may-2026/sai-kitchen-seva-milwaukee-wi"
    },
    {
        title: "Education and Service",
        description: "Restore Butterfly Garden Milwaukee WI",
        image: "/images/exhibition/exhibition-1.jpeg",
        url: "/gallery"
    },
    {
        title: "Engage Parents with Value Education",
        description: "Study Circle - Parent Guide to Value Education",
        image: "/images/dramaskit/drama-1.jpeg",
        url: "/study-circle"
    },
    {
        title: "High Way Cleanup Community Service",
        description: "Maintaining Cleanliness in Milwaukee WI by Engaging Community Members",
        image: "/images/events/event-1.jpeg",
        url: "https://sathyasai.us/media/Jul-2020/highway-cleanup-milwaukee-wisconsin"
    },
    {
        title: "Birthday Beanies Community Service",
        description: "Join us for our next community event!",
        image: "/images/events/event-1.jpeg",
        url: "https://saiuniverse.sathyasai.org/2024/birthday-beanies-for-the-homeless-in-milwaukee-wisconsin/"
    }
]

export { communityimage, foodprepare, foodservice, dramaskits, exhibition, sseImages, centerEvents, articles };